import React from 'react';
import {Bar} from "react-chartjs-2";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useDashboardQuotesGraph
    from "v4/pages/front/Dashboard/components/DashboardQuotesGraph/hooks/useDashboardQuotesGraph";
import {financial} from "v4/utils";
import ErrorBoundary from "components/Error/errorBoundary";
import updateMonthsGraphPlugin
    from "v4/pages/front/Dashboard/components/DashboardQuotesGraph/plugins/updateMonthsGraphPlugin";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import useIsInView from "v4/hooks/useIsInView";

export default function DashboardQuotesGraph() {
    const {t} = usePolTranslation();
    const [ref, isInView] = useIsInView();
    const {
        chartRef,
        tooltipAnchorRef,
        data,
        previousMonth,
        nextMonth,
        resetDateInterval,
        showResetButton,
        canPreviousMonth,
        canNextMonth,
        isLoading,
        onButtonHover,
    } = useDashboardQuotesGraph(isInView);

    return (
        <ErrorBoundary canRetry>
            <div className="dashboard-quotes-graph" ref={ref}>
                <p className="dashboard-quotes-graph__title">{t('the_sales')}</p>
                <div className="dashboard-quotes-graph__graph">
                    <div ref={tooltipAnchorRef}
                         data-for="dashboard-quotes-graph-tooltip"
                         style={{position: 'absolute', pointerEvents: 'none'}}/>
                    <ReactTooltip id="dashboard-quotes-graph-tooltip" effect="solid"/>

                    <Bar ref={chartRef}
                         data={data}
                         plugins={[updateMonthsGraphPlugin]}
                         options={{
                             maintainAspectRatio: false,
                             legend: {position: 'bottom'},
                             scales: {
                                 xAxes: [{
                                     ticks: {
                                         callback: (label) => {
                                             const currentDate = moment();
                                             const [monthName, year] = label.split(' ');
                                             const tickDate = moment(`${year}-${monthName}`, 'YYYY-MMMM');

                                             if (tickDate.isSame(currentDate, 'month')) {
                                                    return `> ${label} <`;
                                             } else {
                                                    return label;
                                             }
                                         }
                                     }
                                 }],
                                 yAxes: [{
                                     ticks: {
                                         beginAtZero: true,
                                         // Chart.js invokes the tick callback as (value, index, ticks);
                                         // wrap so financial() only receives the value (otherwise index/ticks
                                         // land in hasDecimals/scale and blow up Intl.NumberFormat).
                                         callback: (value) => financial(value),
                                     }
                                 }]
                             },
                             tooltips: {
                                 callbacks: {
                                     label: ({yLabel}) => financial(yLabel)
                                 }
                             },
                             plugins: {
                                 updateMonthsGraphPlugin: {
                                     enabled: true,
                                     onPrevClick: previousMonth,
                                     onNextClick: nextMonth,
                                     onResetClick: resetDateInterval,
                                     showResetButton,
                                     canPreviousMonth,
                                     canNextMonth,
                                     isLoading,
                                     buttonsDisabled: isLoading,
                                     onButtonHover,
                                 }
                             }
                         }}
                    />
                </div>
            </div>
        </ErrorBoundary>
    )
}
